export default __webpack_public_path__ + "static/S1-Biome-02d5e9d24c8fdbabe27794cd8e675371.webp";